module.exports = __webpack_public_path__ + "static/moc-b6e957d1293b8ddb2fbe18a6d9990654.png";